import {
    START_BACKGROUND_TIMER,
    UPDATE_BACKGROUND_TIMER,
} from '../actions/timer';

export const timerReducer = (state = {}, action) => {
    switch (action.type) {
        case START_BACKGROUND_TIMER:
            return {
                ...state,
                timerStartedAt: action.payload.timerStartedAt,
                remainingDuration: action.payload.remainingDuration,
                isTimerExpired: false,
            };

        case UPDATE_BACKGROUND_TIMER:
            return {
                ...state,
                remainingDuration: action.payload.remainingDuration,
                isTimerExpired: action.payload.isTimerExpired,
            };

        default:
            return state;
    }
};
